var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWalletRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6214 10.2095H17.7143V12.7905H14.6214C13.9643 12.7905 13.4286 12.2109 13.4286 11.5C13.4286 10.7891 13.9643 10.2095 14.6214 10.2095Z",
    fill: "#A91B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8571 3H4.14286C2.96429 3 2 4.04318 2 5.31818V17.6818C2 18.9568 2.96429 20 4.14286 20H19.8571C21.0357 20 22 18.9568 22 17.6818V5.31818C22 4.04318 21.0357 3 19.8571 3ZM19.1429 13.5632C19.1429 13.9882 18.8214 14.3359 18.4286 14.3359H14.6214C13.1714 14.3359 12 13.0609 12 11.5C12 9.93909 13.1714 8.66409 14.6214 8.66409H18.4286C18.8214 8.66409 19.1429 9.01182 19.1429 9.43682V13.5632Z",
    fill: "#A91B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletRed);
export default __webpack_public_path__ + "static/media/icon_wallet_red.87c5cb06a1d41ce4ced91fcbec0ed166.svg";
export { ForwardRef as ReactComponent };